import { z } from "zod/v3";

export const MAX_PROJECT_PHASE_ACRONYM_LENGTH = 5;
export const MAX_PROJECT_PHASE_NAME_LENGTH = 80;

export const projectPhaseFormSchema = z.object({
  number: z
    .number({
      required_error: "Phase number is required",
      invalid_type_error: "Phase number must be a number",
    })
    .int("Phase number must be a whole number")
    .nonnegative("Phase number cannot be negative"),

  acronym: z
    .string()
    .trim()
    .min(1, "Phase acronym is required")
    .max(
      MAX_PROJECT_PHASE_ACRONYM_LENGTH,
      `Phase acronym must be at most ${MAX_PROJECT_PHASE_ACRONYM_LENGTH} characters`,
    )
    .transform((value) => value.toUpperCase()),

  name: z
    .string()
    .trim()
    .min(1, "Phase name is required")
    .max(
      MAX_PROJECT_PHASE_NAME_LENGTH,
      `Phase name must be at most ${MAX_PROJECT_PHASE_NAME_LENGTH} characters`,
    ),

  color: z
    .string()
    .trim()
    .regex(/^#[0-9A-Fa-f]{6}$/, "Color must be a valid hexadecimal color")
    .transform((value) => value.toUpperCase()),
});

export type ProjectPhaseFormInput = z.input<typeof projectPhaseFormSchema>;

export type ProjectPhaseFormData = z.output<typeof projectPhaseFormSchema>;
